import { getBetaAvailable } from '~/features';

export function isBetaEnabled(): boolean {
  return getBetaAvailable() && localStorage.getItem('beta') === 'true';
}
